import CssBaseline from '@mui/material/CssBaseline'
import { CssVarsProvider, createTheme } from '@mui/material/styles'

import themeOptions from './ThemeOptions'

const ThemeComponent = props => {
  // ** Props
  const { settings, children } = props
  const { mode } = settings

  const coreThemeConfig = themeOptions(settings)

  let theme = createTheme(coreThemeConfig)

  return (
    <CssVarsProvider
      theme={theme}
      defaultMode={mode}
      modeStorageKey='insightwin-mui-mode'
    >
      <CssBaseline />
      {children}
    </CssVarsProvider>
  )
}

export default ThemeComponent
